<template lang="pug">
  m-table(
    store-name="admindocuments"
    :headers="headers"
    :query-filter="queryFilter"
    :item-actions="actions"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'
import { documentStates } from '~/modules/documents/constants/documents'
import contentDialogContentTop from '~/mixins/dialogs/contentDialogContentTop'

export default {
  name: 'BlockUserDocuments',
  components: { MTable },
  mixins: [contentDialogContentTop],
  props: {
    entityId: {
      type: String,
      default: null
    },
    filterName: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          value: 'title',
          sortable: false,
          filterable: false
        },
        {
          text: 'Document state',
          value: 'state',
          component: 'e-status-chip',
          componentProps: {
            statuses: documentStates
          },
          sortable: false,
          filterable: false
        },
        {
          text: 'Signature type',
          valueFormatter: document => this.$t(document.signatureType),
          sortable: false,
          filterable: false
        },
        {
          text: 'Date',
          valueFormatter: document =>
            document.createdAt
              ? this.$moment.parseZone(document.createdAt).format('DD.MM.YYYY')
              : '-',
          sortable: false,
          filterable: false
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
          width: '72',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        [this.filterName]: this.entityId
      }
    },
    actions() {
      return [
        {
          name: 'details',
          text: 'Document detail',
          call: document => this.showDocumentDetails(document)
        }
      ]
    }
  },
  methods: {
    showDocumentDetails(document) {
      this.contentDialogContentTop.open({
        width: '1000px',
        component: 'm-document-details',
        componentProps: {
          document
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
